export const getAccessoryByHandleQuery = `
    query getAccessoryByHandle($handle: String){
      product(handle:$handle) {
        id
        title
        handle
        tags
        featuredImage {
          url
          altText
        }
        priceRange {
          maxVariantPrice {
            amount
          }
        }
        variants(first: 1) {
          nodes{
            id
            price {
              amount
            }
          }
        }
      }
    }
`
